<template>
  <transition
    name="unpin-slide"
    @after-leave="afterLeave"
  >
    <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.billing, collapsed: !expanded.billing }">
    <div class="info-card-content">
      <div v-if="!expanded.billing">
        <div class="info-row">
          <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4.66667 12.1667C4.90278 12.1667 5.10069 12.0868 5.26042 11.9271C5.42014 11.7674 5.5 11.5694 5.5 11.3333C5.5 11.0972 5.42014 10.8993 5.26042 10.7396C5.10069 10.5799 4.90278 10.5 4.66667 10.5C4.43056 10.5 4.23264 10.5799 4.07292 10.7396C3.91319 10.8993 3.83333 11.0972 3.83333 11.3333C3.83333 11.5694 3.91319 11.7674 4.07292 11.9271C4.23264 12.0868 4.43056 12.1667 4.66667 12.1667ZM4.66667 8.83333C4.90278 8.83333 5.10069 8.75347 5.26042 8.59375C5.42014 8.43403 5.5 8.23611 5.5 8C5.5 7.76389 5.42014 7.56597 5.26042 7.40625C5.10069 7.24653 4.90278 7.16667 4.66667 7.16667C4.43056 7.16667 4.23264 7.24653 4.07292 7.40625C3.91319 7.56597 3.83333 7.76389 3.83333 8C3.83333 8.23611 3.91319 8.43403 4.07292 8.59375C4.23264 8.75347 4.43056 8.83333 4.66667 8.83333ZM4.66667 5.5C4.90278 5.5 5.10069 5.42014 5.26042 5.26042C5.42014 5.10069 5.5 4.90278 5.5 4.66667C5.5 4.43056 5.42014 4.23264 5.26042 4.07292C5.10069 3.91319 4.90278 3.83333 4.66667 3.83333C4.43056 3.83333 4.23264 3.91319 4.07292 4.07292C3.91319 4.23264 3.83333 4.43056 3.83333 4.66667C3.83333 4.90278 3.91319 5.10069 4.07292 5.26042C4.23264 5.42014 4.43056 5.5 4.66667 5.5ZM7.16667 12.1667H12.1667V10.5H7.16667V12.1667ZM7.16667 8.83333H12.1667V7.16667H7.16667V8.83333ZM7.16667 5.5H12.1667V3.83333H7.16667V5.5ZM2.16667 15.5C1.70833 15.5 1.31597 15.3368 0.989583 15.0104C0.663194 14.684 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663194 1.31597 0.989583 0.989583C1.31597 0.663194 1.70833 0.5 2.16667 0.5H13.8333C14.2917 0.5 14.684 0.663194 15.0104 0.989583C15.3368 1.31597 15.5 1.70833 15.5 2.16667V13.8333C15.5 14.2917 15.3368 14.684 15.0104 15.0104C14.684 15.3368 14.2917 15.5 13.8333 15.5H2.16667ZM2.16667 13.8333H13.8333V2.16667H2.16667V13.8333Z" fill="#374957"/>
            </svg>
          </div>
          <p class="info-text-title">Billing Preference:</p>
        </div>
      </div>
          <div v-else> 
            <div class="flex flex-row gap-2">
              <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                  <path d="M18 0H2C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.11 0 18 0ZM18 14H2V8H18V14ZM18 4H2V2H18V4Z" fill="#374957"/>
                </svg>
              </div>
              <div class="flex flex-col gap-1">
                <p class="info-text-title">Billing Preference:</p>
                <span class="badge badge-default">As Default</span>
                <p class="info-text">{{ billingData.method }}</p>
              </div>
            </div>
            <div class="flex flex-row gap-2">
              <div class="icon-container mt-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 16 20" fill="none">
                  <path d="M8 17.35C10.0333 15.4833 11.5417 13.7875 12.525 12.2625C13.5083 10.7375 14 9.38333 14 8.2C14 6.38333 13.4208 4.89583 12.2625 3.7375C11.1042 2.57917 9.68333 2 8 2C6.31667 2 4.89583 2.57917 3.7375 3.7375C2.57917 4.89583 2 6.38333 2 8.2C2 9.38333 2.49167 10.7375 3.475 12.2625C4.45833 13.7875 5.96667 15.4833 8 17.35ZM8 20C5.31667 17.7167 3.3125 15.5958 1.9875 13.6375C0.6625 11.6792 0 9.86667 0 8.2C0 5.7 0.804167 3.70833 2.4125 2.225C4.02083 0.741667 5.88333 0 8 0C10.1167 0 11.9792 0.741667 13.5875 2.225C15.1958 3.70833 16 5.7 16 8.2C16 9.86667 15.3375 11.6792 14.0125 13.6375C12.6875 15.5958 10.6833 17.7167 8 20Z" fill="#374957"/>
                <path d="M7.37433 15V13.5667C6.80749 13.4333 6.31818 13.1778 5.90642 12.8C5.49465 12.4222 5.19251 11.8889 5 11.2L6.18717 10.7C6.34759 11.2333 6.58556 11.6389 6.90107 11.9167C7.21658 12.1944 7.63102 12.3333 8.14439 12.3333C8.58289 12.3333 8.95455 12.2306 9.25936 12.025C9.56417 11.8194 9.71658 11.5 9.71658 11.0667C9.71658 10.6778 9.59893 10.3694 9.36364 10.1417C9.12834 9.91389 8.58289 9.65556 7.72727 9.36667C6.80749 9.06667 6.17647 8.70833 5.83422 8.29167C5.49198 7.875 5.32086 7.36667 5.32086 6.76667C5.32086 6.04444 5.54545 5.48333 5.99465 5.08333C6.44385 4.68333 6.90374 4.45556 7.37433 4.4V3H8.65775V4.4C9.19251 4.48889 9.63369 4.69167 9.98128 5.00833C10.3289 5.325 10.5829 5.71111 10.7433 6.16667L9.55615 6.7C9.42781 6.34444 9.24599 6.07778 9.01069 5.9C8.7754 5.72222 8.45455 5.63333 8.04813 5.63333C7.57754 5.63333 7.21925 5.74167 6.97326 5.95833C6.72727 6.175 6.60428 6.44444 6.60428 6.76667C6.60428 7.13333 6.76471 7.42222 7.08556 7.63333C7.40642 7.84444 7.96257 8.06667 8.75401 8.3C9.49198 8.52222 10.0508 8.875 10.4305 9.35833C10.8102 9.84167 11 10.4 11 11.0333C11 11.8222 10.7754 12.4222 10.3262 12.8333C9.87701 13.2444 9.32086 13.5 8.65775 13.6V15H7.37433Z" fill="#374957"/>
              </svg>
              </div>
              <div class="flex flex-col gap-1 mt-2">
                <p class="info-text-title">Billing Address:</p>
                <p class="info-text">{{ billingData.address }}</p>
              </div>
          </div>
        </div>
        <div v-if="expanded.billing" class="action-icons">
          <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
            <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
          </div>
          <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
            <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
          </div>
          <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('billing')">
            <img src="@/assets/cardActions/collapse.svg" alt="Collapse" />
          </div>
        </div>
        <div v-else class="flex flex-row items-center gap-2">
          <div @click.stop="toggleCard('billing')" class="action-icon">
            <img src="@/assets/cardActions/expand.svg" alt="Expand" />
          </div>
          <div class="drag-handle action-icon">
            <img src="@/assets/cardActions/move.svg" alt="Move" />
          </div>
        </div>
    </div>
    <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
      <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
        <template #prefix>
          <img src="@/assets/cardActions/move.svg" alt="Move" />
        </template>
      </FoldableButton>
      <div class="flex flex-row gap-1 justify-end">
        <FoldableButton text="View">
          <template #prefix>
            <img src="@/assets/cardActions/view.svg" alt="View" />
          </template>
        </FoldableButton>
        <FoldableButton text="Resend">
          <template #prefix>
            <img src="@/assets/cardActions/resend.svg" alt="Resend" />
          </template>
        </FoldableButton>
      </div>
    </div>
  </div>
</transition>


</template>
<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useCardActions } from '@/composables/useCardActions';
import { useMyPatientsStore } from '@/store/helpers';

// Define props
const props = defineProps({
  patient: {
    type: String,
    default: ''
  },
  cardData: {
    type: Object,
    default: () => ({})
  },
  showFooter: {
    type: Boolean,
    default: true
  }
})

// Define emits
const emit = defineEmits(['unpin-card', 'pin-card']);

const { patientInfoStore } = useMyPatientsStore();
const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit);

const isLeaving = ref(false);


const startUnpin = () => {
  if(props.showFooter){
    isLeaving.value = true; // triggers the leave animation
  } else {
    handleUnpinCard()
  }
};


// This is called after the leave animation finishes
const afterLeave = () => {
  emit('unpin-card', props.cardData); // parent removes the card
};




const expanded = ref({
  billing: true,
    })

const toggleCard = (cardType) => {
      expanded.value[cardType] = !expanded.value[cardType]
    }


// Get billing data from store
const billingData = computed(() => {
  return patientInfoStore.getters.getBillingCardData(props.patient) || {
    method: 'Not Provided',
    address: 'Not Provided', 
  }
})



</script>


<style scoped>
.pin-toggle {
  position: relative;
  cursor: pointer;
}

.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}

/* Hover effect */
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}

.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}


.unpin-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.unpin-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}

.peg-board-title {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 16px;
}

.peg-board-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  padding: 0 8px;
}

.info-card {
  background-color: white;
  border-radius: 5px;
  padding: 12px 16px;
  box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
}

.info-card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.info-card-content-col-group {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
}

.info-row-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-container {
  background-color: #f2f2f2;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-style {
  width: 20px;
  height: 20px;
}

.info-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0.25px;
  line-height: 20px;
}

.action-icons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.appointment-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 50px;
  height: 64px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
  overflow: hidden;
}

.month {
  background-color: #004879;
  color: white;
  width: 100%;
  text-align: center;
  padding: 2px 0;
  font-size: 14px;
}

.day {
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */
  text-transform: capitalize;
  height: 24px;
}

.weekday {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1;
  padding-bottom: 3px;
}

.appointment-details {
    flex-grow: 1;
}

.detail-title {
    font-size: 12px;
    color: #666;
}
.detail-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
}
.action-icons-appointment {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 20px;
}
.info-text-title {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #666;
}
.info-text-large {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

/* Badge for billing preference */
.badge {
  color: #25B8C2;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
  letter-spacing: 0.25px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-family: 'Inter', sans-serif;
}

.badge-default {
  border-radius: 20px;
  background: #EBFFF8;
  width: 80px;
  font-family: 'Inter', sans-serif;
}

/* Expanded card footer visibility with hover expand animation */
.card-expand {
  display: flex;
  align-items: center;
  gap: 16px;
  /* animation base state */
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
  border-top: 1px dashed var(--DividerGray, #C4C4C4);
  border-top-color: transparent;
  pointer-events: none;
  transition: max-height 300ms linear,
              opacity 300ms linear,
              padding-top 300ms linear,
              margin-top 300ms linear,
              border-top-color 300ms linear;
}

.info-card.expanded:hover .card-expand {
  /* ensure enough room for actions */
  max-height: 80px;
  opacity: 1;
  padding-top: 10px;
  margin-top: 10px;
  border-top-color: var(--DividerGray, #C4C4C4);
  pointer-events: auto;
}

.expand-action {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1B79A0;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 5px;
}

.expand-action span {
  color: var(--color-Darkblue-000, #1E4670);
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}


.action-icon {
  width: 28px;          /* w-7 */
  height: 28px;         /* h-7 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;   /* rounded-[5px] */
  padding: 5px;         /* pd-5 (assuming you meant padding) */
  cursor: pointer;
  transition: background-color 0.2s; /* duration-200 transition-colors */
}

.action-icon:hover,
.expand-action:hover {
  background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
}
</style>
